import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const inputCls = 'w-full px-6 py-4 bg-zinc-800 rounded-2xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500';

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('fb_token') || ''}`
});

export default function SignInGate({ children }) {
  const token = localStorage.getItem('fb_token');
  const uid = localStorage.getItem('fb_uid');
  const signedIn = !!(token && uid);

  const [state, setState] = useState(
    signedIn && localStorage.getItem('fb_profile_ok') !== uid ? 'checking' : 'ok'
  );
  const [surname, setSurname] = useState('');
  const [cc, setCc] = useState('+27');
  const [cell, setCell] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (state !== 'checking') return undefined;
    let cancelled = false;
    fetch(`${BACKEND}/api/auth/profile-status/${uid}`, { headers: authHeaders() })
      .then(r => (r.ok ? r.json() : null))
      .then(d => {
        if (cancelled) return;
        if (d && d.complete === false) {
          setState('needs');
        } else {
          if (d && d.complete) { try { localStorage.setItem('fb_profile_ok', uid); } catch (e) {} }
          setState('ok');
        }
      })
      .catch(() => { if (!cancelled) setState('ok'); });
    return () => { cancelled = true; };
  }, [state, uid]);

  if (!signedIn) {
    try {
      const ref = new URLSearchParams(window.location.search).get('ref');
      if (ref) localStorage.setItem('fb_ref', ref);
    } catch (e) {}
    return <Navigate to="/signup" replace />;
  }

  if (state === 'checking') {
    return (
      <div style={{ background: '#000', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#666' }}>
        Loading...
      </div>
    );
  }

  if (state === 'needs') {
    const submit = async (e) => {
      e.preventDefault();
      setError('');
      const code = cc.trim();
      if (!surname.trim()) { setError('Please enter your surname.'); return; }
      if (!/^\+\d{1,4}$/.test(code)) { setError('Country code must look like +27'); return; }
      let digits = cell.replace(/\D/g, '');
      if (digits.startsWith('0')) digits = digits.slice(1);
      if (digits.length < 6 || digits.length > 12) { setError('Please enter a valid cell number.'); return; }
      setSaving(true);
      try {
        const r = await fetch(`${BACKEND}/api/auth/complete-profile`, {
          method: 'POST',
          headers: authHeaders(),
          body: JSON.stringify({ uid, surname: surname.trim(), country_code: code, cell_number: digits })
        });
        if (!r.ok) { setError('Could not save. Please try again.'); return; }
        try { localStorage.setItem('fb_profile_ok', uid); } catch (err) {}
        setState('ok');
      } catch {
        setError('Something went wrong. Please try again.');
      } finally {
        setSaving(false);
      }
    };

    return (
      <div className="min-h-screen bg-black flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-zinc-900 rounded-3xl p-10">
          <h1 className="text-3xl font-bold text-center mb-2 text-white">Almost there</h1>
          <p className="text-gray-400 text-center text-sm mb-8">Please add your details to keep using Family Binge. It stays free.</p>
          {error && <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-3 mb-4 text-red-400 text-sm">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <input type="text" placeholder="Surname" value={surname} onChange={e => setSurname(e.target.value)} className={inputCls} required />
            <div className="flex gap-3">
              <input type="text" placeholder="+27" value={cc} onChange={e => setCc(e.target.value)} className="w-28 px-4 py-4 bg-zinc-800 rounded-2xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500" required />
              <input type="tel" placeholder="Cell number" value={cell} onChange={e => setCell(e.target.value)} className="flex-1 px-6 py-4 bg-zinc-800 rounded-2xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500" required />
            </div>
            <p className="text-xs text-gray-500">We collect your name, surname, email and cell number to run your Family Binge account and understand how the app is used.</p>
            <button type="submit" disabled={saving} className="w-full py-4 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-2xl transition-colors">
              {saving ? 'Saving...' : 'Continue'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return children;
}